const mode = process.env.NODE_ENV;

function loadConfigs() {

    let scheme          = {};
    let apiConfig       = {};
    let servicesConfig  = {};

    switch (mode) {

        case "development":

            apiConfig       = require("config/development/api.yaml");
            servicesConfig  = require("config/development/services.yaml");

            scheme = {
                app: {
                    name:           "nexusAPI",
                    description:    "Very Cool app to manage API resources in your eco-system",
                    //version: version,
                    mode:           mode,
                    devtools:       true,
                    productionTip:  false
                },
                api: {
                    email:      apiConfig.default.api.email,
                    password:   apiConfig.default.api.password
                },
                services: {
                    google: {
                        maps: {
                            api_key:    servicesConfig.default.service.google.maps.api_key
                        }
                    }
                }
            };

            return scheme;

        case "production":

            apiConfig       = require("config/production/api.yaml");
            servicesConfig  = require("config/production/services.yaml");

            scheme = {
                app: {
                    name: "nexusAPI",
                    description: "Very Cool app to manage API resources in your eco-system",
                    //version: version,
                    mode: mode,
                    devtools: true,
                    productionTip: false
                },
                api: {
                    email:      apiConfig.default.api.email,
                    password:   apiConfig.default.api.password
                },
                services: {
                    google: {
                        maps: {
                            api_key:    servicesConfig.default.service.google.maps.api_key
                        }
                    }
                }
            };

            return scheme;

        default:

            return scheme;
    }
}

export default loadConfigs()